import { Skeleton } from "@mui/material";

function EditItemBagDialogSkeleton() {
  return <>
    <Skeleton
      variant="rectangular"
      animation="wave"
      sx={{
        borderRadius: "7px",
        width: "100%",
        height: {
          xs: "180px",
          sm: "200px",
          md: "280px",
        },
      }}
    />
    <Skeleton
      variant="text"
      sx={{ width: "40%" }}
      animation="wave"
    />
    <Skeleton
      variant="text"
      sx={{ width: "20%" }}
      animation="wave"
    />
  </>;
}

export default EditItemBagDialogSkeleton;